import {
  PasswordInput as RawPasswordInput,
  PasswordInputProps as RawPasswordInputProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface PasswordInputProps
  extends Omit<RawPasswordInputProps, 'type'> {
  type: 'password';
  name: string;
}

export default function PasswordInput(props: PasswordInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    type,
    error,
    placeholder,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;
  const _placeholder = React.useMemo(() => {
    if (_disabled) return undefined;
    return placeholder;
  }, [_disabled, placeholder]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawPasswordInput
      {...rest}
      {...field}
      type={type}
      value={field.value}
      placeholder={_placeholder}
      onChange={(e) => {
        field.onChange(e.target.value);
        onChange?.(e);
      }}
      disabled={_disabled}
      error={_error}
      withAsterisk={withAsterisk}
    />
  );
}
